var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "v-row",
    [
      _c(
        "v-col",
        {
          attrs: {
            cols: "12"
          }
        },
        [
          _c(
            "gg-card",
            [
              _c(
                "gg-card-header",
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "d-md-flex justify-space-between",
                          attrs: {
                            cols: "12",
                            md: "6"
                          }
                        },
                        [
                          _c("div", [_vm._v(" Domains ")]),
                          _c("v-slide-x-transition", [
                            _vm.selectedDomain
                              ? _c(
                                  "div",
                                  [
                                    _c(
                                      "gg-btn",
                                      {
                                        staticClass: "my-1 my-md-0 mx-1",
                                        attrs: {
                                          secondary: ""
                                        },
                                        on: {
                                          click: function click($event) {
                                            _vm.selectedDomain = null
                                          }
                                        }
                                      },
                                      [_vm._v("Go Back")]
                                    ),
                                    _c(
                                      "gg-btn",
                                      {
                                        staticClass: "my-1 my-md-0 mx-1",
                                        on: {
                                          click: function click($event) {
                                            return _vm.detailsAction("reload")
                                          }
                                        }
                                      },
                                      [_vm._v("Refresh List")]
                                    ),
                                    _c(
                                      "gg-btn",
                                      {
                                        staticClass: "my-1 my-md-0 mx-1",
                                        on: {
                                          click: function click($event) {
                                            return _vm.detailsAction("reset")
                                          }
                                        }
                                      },
                                      [_vm._v("Reset Zone")]
                                    ),
                                    _c(
                                      "v-menu",
                                      {
                                        attrs: {
                                          "offset-y": ""
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function fn(_ref) {
                                                var on = _ref.on
                                                return [
                                                  _c(
                                                    "gg-btn",
                                                    _vm._g(
                                                      {
                                                        staticClass:
                                                          "my-md-0 mx-1"
                                                      },
                                                      on
                                                    ),
                                                    [_vm._v(" Add Record ")]
                                                  )
                                                ]
                                              }
                                            }
                                          ],
                                          null,
                                          false,
                                          3213979919
                                        )
                                      },
                                      [
                                        _c(
                                          "v-list",
                                          [
                                            _c(
                                              "v-list-item",
                                              {
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.detailsAction(
                                                      "addA"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v("Add A Record")
                                                ])
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item",
                                              {
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.detailsAction(
                                                      "addAAA"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v("Add AAA Record")
                                                ])
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item",
                                              {
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.detailsAction(
                                                      "addCAA"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v("Add CAA Record")
                                                ])
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item",
                                              {
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.detailsAction(
                                                      "addCNAME"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v("Add CNAME Record")
                                                ])
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item",
                                              {
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.detailsAction(
                                                      "addDMARK"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v("Add DMARC Record")
                                                ])
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item",
                                              {
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.detailsAction(
                                                      "addMX"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v("Add MX Record")
                                                ])
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item",
                                              {
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.detailsAction(
                                                      "addSRV"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v("Add SRV Record")
                                                ])
                                              ],
                                              1
                                            ),
                                            _c(
                                              "v-list-item",
                                              {
                                                on: {
                                                  click: function click(
                                                    $event
                                                  ) {
                                                    return _vm.detailsAction(
                                                      "addTXT"
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v("Add TXT Record")
                                                ])
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ])
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        {
                          staticClass: "font-weight-regular",
                          attrs: {
                            cols: "12",
                            md: "6"
                          }
                        },
                        [
                          _c("gg-text-field", {
                            attrs: {
                              "hide-details": "",
                              placeholder: "Search",
                              "append-icon": "mdi-magnify"
                            },
                            model: {
                              value: _vm.domainSearch,
                              callback: function callback($$v) {
                                _vm.domainSearch = $$v
                              },
                              expression: "domainSearch"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "gg-card-text",
                [
                  !_vm.selectedDomain
                    ? _c("domains-table", {
                        attrs: {
                          "is-reseller-owner": _vm.isResellerOwner,
                          "is-reseller-route": _vm.isResellerRoute,
                          search: _vm.domainSearch,
                          "table-should-be-reloaded": false
                        },
                        on: {
                          "show-details": function showDetails($event) {
                            return _vm.showDetails($event)
                          }
                        }
                      })
                    : _c("details-table", {
                        ref: "detailsTable",
                        attrs: {
                          "table-should-be-reloaded": false,
                          search: _vm.domainSearch,
                          domain: _vm.selectedDomain,
                          username: _vm.selectedUsername
                        },
                        on: {
                          "domain-error": _vm.hideDetails,
                          back: _vm.hideDetails
                        }
                      })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }